<!--
 * @Description: 
 * @Version: 
 * @Autor: houcf
 * @Date: 2023-05-10 11:19:14
 * @LastEditTime: 2023-05-10 11:45:01
-->
<template>
  <div :style="{fontSize: size +'px'}">
    <svg class="g-icon" aria-hidden="true">
      <use :xlink:href="'#icon-'+name"></use>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.g-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>